module.exports = __webpack_public_path__ + "img/fg2.9b317684.jpg";